import styled from "styled-components";

export const Description = styled.div`
  h1,
  span,
  p {
    color: #1a3458;
  }

  h1 {
    font-size: 37px;
    margin-bottom: 8px;
    max-width: 627px;
  }

  span {
    font-size: 23px;
  }

  p {
    margin-top: 35px;
  }

  @media (max-width: 425px) {
    h1 {
      font-size: 25px;
    }
  }
`;
